import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_ADMIN_URL;

export const fetchAllCategories = async () => {
  const res = await axios.get(`${BASE_URL}/get-categories`);
  return res.data.data;
};
